import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
	get_admin_profile,
	update_admin_profile,
} from '../../redux/actions/adminAuthActions'
// import {
// 	UPDATE_ADMIN_PROFILE_RESET,
// 	GET_ADMIN_PROFILE_RESET,
// } from '../../redux/types'
import Loader from '../../components/Loader'

const DashboardProfile = () => {
	const dispatch = useDispatch()

	const [name, setName] = useState('')
	const [password, setPassword] = useState('')
	const [confirmPassword, setConfirmPassword] = useState('')
	const [email, setEmail] = useState('')

	const getAdminProfile = useSelector((state) => state.getAdminProfile)
	const { loading, profile } = getAdminProfile

	const adminUpdateProfile = useSelector((state) => state.adminUpdateProfile)
	const { loading: loadingUpdate, success } = adminUpdateProfile

	const adminAuth = useSelector((state) => state.adminAuth)
	const { detail } = adminAuth

	const submitHandler = (e) => {
		e.preventDefault()
		let data = {
			name,
			password,
		}
		dispatch(update_admin_profile(detail.id, data))
	}

	useEffect(() => {
		if (!profile || detail.id !== profile._id) {
			dispatch(get_admin_profile(detail.id))
		} else {
			setEmail(profile.email)
			setName(profile.name)
		}
	}, [dispatch, detail, profile._id, success])

	return (
		<>
			<section className='user_dashboard'>
				{loading ? (
					<Loader />
				) : profile ? (
					<div className='container'>
						<div className='row justify-content-center'>
							<div className='col-md-10'>
								<div className='user_dashboard_profile_form'>
									<form onSubmit={submitHandler}>
										<div className='row'>
											<div className='col-md-6'>
												<label> Name </label>
												<input
													type='text'
													className='form-control'
													value={name}
													onChange={(e) => setName(e.target.value)}
												/>
											</div>

											<div className='col-md-6'>
												<label> Email </label>
												<input
													type='email'
													className='form-control'
													value={profile.email}
													disabled
													onChange={(e) => setEmail(e.target.value)}
												/>
											</div>
											<div className='col-md-6'>
												<label> Password </label>
												<input
													type='password'
													className='form-control'
													value={password}
													onChange={(e) => setPassword(e.target.value)}
												/>
											</div>
											<div className='col-md-6'>
												<label> Confirm Password </label>
												<input
													type='password'
													className='form-control'
													value={confirmPassword}
													onChange={(e) => setConfirmPassword(e.target.value)}
												/>
											</div>
										</div>
										<div className='text-right'>
											<button
												type='submit'
												disabled={loadingUpdate ? true : false}
												className='btn btn-danger'
											>
												Update
											</button>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				) : (
					'No data to display'
				)}
			</section>
		</>
	)
}

export default DashboardProfile
